import cloud from '../../../images/ayuda/cloud.png';
import Button from '../../elements/buttons/Button';

function ChatAyuda() {

    return (

    <section className="ChatAyuda">
        <div className="wrap">
            <img src={cloud} />
            <h2 className="titles">CHATEA con nuestro <span>asistente virtual</span></h2>
            <p>¡Estamos en línea! Resuelve tus consultas al instante con nuestro Asistente Virtual.</p>
            <Button copy="Iniciar chat" link="/" className="button-primary" />
        </div>
    </section>

  )
}

export default ChatAyuda


